const actions = ['FINISH_STEP', 'SET_STATUS']

const subActions = {}

export default [actions, subActions]
